/* eslint-disable import/no-named-as-default-member */
// Day.JS utils is added here. When the UI folder goes out of bliss, a package.json dep of day.js must be included.
// use this export if you are working with day.js inside of the ui folder please.

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import timezone from 'dayjs/plugin/timezone';
import weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/en-in';

dayjs.locale('en-in');
dayjs.extend(isToday);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isYesterday);
dayjs.extend(timezone);
dayjs.extend(weekday);
dayjs.extend(duration);
dayjs.tz.setDefault('Asia/Kolkata');

export default dayjs;
export type { Dayjs } from 'dayjs';
